import angular from 'angular';

'use strict';

const chatsServices = angular.module('applicationModule.chatsServices', []);

chatsServices.factory('Chat', ['ChatAPI', function (ChatAPI) {

    return {
        getList: function (appId, params) {
            return ChatAPI.getList(appId, params).then(function (response) {
                return response.data;
            });
        },
        getUsersList: function (appId, chatId, params) {
            return ChatAPI.getUsersList(appId, chatId, params).then(function (response) {
                return response.data;
            });
        },
        get: function (chatId, appId) {
            return ChatAPI.getChat(chatId, appId);
        },
        save: function (chat, editMode) {
            if (editMode) {
                return ChatAPI.editChat(chat);
            } else {
                return ChatAPI.createChat(chat);
            }
        },
        remove: function (chatId) {
            return ChatAPI.removeChat(chatId);
        }
    };
}]);

chatsServices.service('ChatAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {

    const API_URL = AppsoupAPI.API_URL + '/app/chat/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getUsersList = function (appId, chatId, params) {
        return $http.get(API_URL + 'users/get', {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                application_id: appId,
                chat_id: chatId
            })
        });
    };

    this.createChat = function (chat) {
        return $http.post(API_URL, chat);
    };
    this.getChat = function (chatId, appId) {
        return $http.get(API_URL + chatId, {params: {application_id: appId}});
    };

    this.editChat = function (chat) {
        return $http.put(API_URL + chat.id, chat);
    };

    this.removeChat = function (chatId) {
        return $http.delete(API_URL + chatId);
    };

}]);

export default chatsServices;
